<div id="password-reset-page" class="container">
  <div class="login-box">
    <div class="logo-container">
      <img id="black-logo" src="../../assets/ProductioneerLogoBlack_Transparent.png" />
      <h4 class="product-title">Password Reset Form</h4>
    </div>

    <form class="login-form" [formGroup]="passResetForm" (ngSubmit)="onPasswordReset()">
      <div *ngIf="resultMessage" class="{{resultMessageClass}} | sanitize">
        {{resultMessage}}
      </div>

      <div *ngIf="!hideForm">
        <div class="form-group">
          <label name="password">New Password</label>
          <div class="input-group">
            <input type="{{passwordType}}" class="form-control" name="password" placeholder="Enter your new password" formControlName="password" />
            <div class="input-group-append">
              <button class="btn btn-secondary" type="button" (click)="showPassword(this)" title="{{passwordBtnTitle}}"><i class="far" [class.fa-eye]="passwordType == 'password'" [class.fa-eye-slash]="passwordType == 'text'"></i></button>
            </div>
          </div>
          <div class="alert alert-warning" *ngIf="passResetForm.controls.password.errors && passResetForm.controls.password.dirty">
            <div>
              Your new password must contain the following:
              <ul>
                <li>At least 8 characters</li>
                <li>At least 1 uppercase and 1 lowercase character</li>
                <li>At least 1 number</li>
                <li>At least 1 of the following characters: .!&#64;#$%^&*(),?"|<></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label name="passwordConfirm">Confirm Password</label>
          <input type="password" class="form-control" name="passwordConfirm" placeholder="Confirm your new password" formControlName="passwordConfirm" />
          <div class="alert alert-warning" *ngIf="(passResetForm.controls.passwordConfirm.errors && passResetForm.controls.passwordConfirm.dirty) || (passResetForm.controls.passwordConfirm.dirty && (passResetForm.value.password != passResetForm.value.passwordConfirm))">
            <div>Please confirm your new password</div>
          </div>
        </div>

        <div class="login-btn-container" *ngIf="!isSubmitting">
          <button type="submit" class="btn btn-danger btn-lg mi4-big-btn" [disabled]="!passResetForm.valid || (passResetForm.value.password != passResetForm.value.passwordConfirm)">Reset Password</button>
        </div>

        <div class="login-btn-container" *ngIf="isSubmitting">
          <button disabled type="button" class="btn btn-danger btn-lg mi4-big-btn"><span class="spinner-border" role="status"></span> Submitting</button>
        </div>
      </div>

      <div class="alternate-link-container">
        <a routerLink="/login" class="btn btn-outline-secondary mi4-big-link">Go to Login</a>
      </div>
    </form>
  </div>
</div>

<app-footer></app-footer>
